import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import Icon from '../../components/stateless/Icon';
import Button from '../../components/statefull/Button';

import { getData } from '../../helpers/postData';

import './index.scss';
import { removeTime } from '../../helpers';

function ProductsBlogCategory() {
  const [data, setData] = useState({ changelog: [], count: 0 });
  const [offset, setOffset] = useState(0);
  const { category } = useParams();
  const categoryName = category === 'companyNews'
    ? 'News'
    : category === 'blog'
      ? 'Blog'
      : category === 'educational'
        ? 'Educational'
        : category;
  const markup = (str) => ({ __html: str });
  const query = (skip, take, slug) => `/rss-news?order=desc&offset=${skip}${slug?.length ? `&slugs[]=${slug}` : ''}&limit=${take}`;

  const loadMore = () => {
    setOffset(prev => prev + 8);
  }

  useEffect(async () => {
    const { data } = await getData(`/rss-news?order=desc&offset=${offset}&slugs[]=${category}&limit=8`);

    setData(prev => ({
      changelog: [...prev.changelog, ...data.changelog],
      count: data.count,
    }));
  }, [getData, category, offset]);

  return (
    <>
      <div className="news-content-wrap">
        <div className="news-content-layout">
          <div className="all-news">
            <div className="group-heading-link">
              <Link to="/products-blog">
                <Icon icon="back-icon"/>
                <p className="group-desc-title">All News</p>
              </Link>
              <Icon icon="dot-icon"/>
              <p className="group-desc-title">{categoryName}</p>
            </div>
            <div className="news-grid-layout">
              {
                data.changelog?.map(news =>
                  <Link to={'/products-blog/' + news.categorySlug + '/' + news.id} key={news.id}
                        className="single-news">
                    <div className="image-block" key={news.id}>
                      <div className="image-block-inner" style={{ backgroundImage: `url("${news.fileUrl}")` }}/>
                    </div>
                    <div className="news-info">
                      <div className="inner-content">
                        <div className="main">
                          <div className="news-title">{news.title}</div>
                          <p className="news-content" dangerouslySetInnerHTML={markup(news.preview)}/>
                        </div>
                      </div>
                    </div>
                    <div className="news-views-date">
                      <span className="date">{removeTime(news.updatedAt)}</span>
                    </div>
                  </Link>
                )
              }
            </div>
            {
              data.count > offset + 8
                ? <Button stroked={true} content="Load More" onClick={loadMore}/>
                : ''
            }
          </div>
        </div>
      </div>
    </>
  );
}

export default ProductsBlogCategory;
